module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.show && _vm.isConnectionError) ? _c('div', {
    staticClass: "connection-error",
    attrs: {
      "transition": "fade"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-flash blink"
  }), _vm._v("\n      " + _vm._s(_vm.$t('error.connection')) + "\n      "), _c('a', {
    staticClass: "close",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.show = false
      }
    }
  }, [_vm._v("×")])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.show && !_vm.isConnectionError) ? _c('div', {
    staticClass: "error-mask",
    class: {
      'modal-mask': _vm.modal, 'banner-mask': !_vm.modal
    }
  }, [_c('a', {
    staticClass: "close",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.show = false
      }
    }
  }, [_vm._v("❌")]), _vm._v(" "), _c('div', {
    class: {
      'modal-wrapper': _vm.modal, 'banner-wrapper': !_vm.modal
    }
  }, [_c('div', {
    class: {
      'modal-container': _vm.modal, 'banner-container': !_vm.modal
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isServerError),
      expression: "isServerError"
    }]
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('error.generic')))]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('error.server'))
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('error.apologies'))
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('error.help'))
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isForbidden),
      expression: "isForbidden"
    }]
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('error.access_denied')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('error.forbidden')))]), _vm._v(" "), _c('p', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('error.contact_us'))
    }
  })])])])])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46528002"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Error.vue
// module id = 1037
// module chunks = 1